"use client";

import { useChatActions } from "@ai-sdk-tools/store";
import { ArrowLeft } from "lucide-react";
import { useRouter } from "next/navigation";
import { useChatInterface } from "@/hooks/use-chat-interface";

export function ChatNavigation() {
  const router = useRouter();
  const { reset } = useChatActions();
  const { isChatPage } = useChatInterface();

  const handleBack = () => {
    reset();
    router.push("/");
  };

  if (!isChatPage) return null;

  return (
    <div className="absolute left-0">
      <button
        type="button"
        onClick={handleBack}
        className="group p-2.5 hover:bg-[var(--mindup-pink-light)] dark:hover:bg-white/5 rounded-xl transition-all duration-200 hover:shadow-sm"
        aria-label="Back to home"
      >
        <ArrowLeft className="w-4 h-4 text-gray-400 group-hover:text-[var(--mindup-pink)] transition-colors" />
      </button>
    </div>
  );
}
